var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitHourglassCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C10.1217 7.07185e-06 12.1569 0.842489 13.6572 2.34277C15.1575 3.84306 16 5.87827 16 8C16 10.1217 15.1575 12.1569 13.6572 13.6572C12.1569 15.1575 10.1217 16 8 16C5.87827 16 3.84306 15.1575 2.34277 13.6572C0.842482 12.1569 0 10.1217 0 8C1.76798e-06 5.87827 0.842484 3.84306 2.34277 2.34277C3.84306 0.842493 5.87828 0 8 0ZM5.31348 4C5.10637 4 4.93848 4.16789 4.93848 4.375V4.625C4.93848 4.83211 5.10637 5 5.31348 5C5.31348 6.42115 6.11035 7.62069 7.20117 8C6.11035 8.37931 5.31348 9.57885 5.31348 11C5.10637 11 4.93848 11.1679 4.93848 11.375V11.625C4.93848 11.8321 5.10637 12 5.31348 12H10.5635C10.7706 12 10.9385 11.8321 10.9385 11.625V11.375C10.9385 11.1679 10.7706 11 10.5635 11C10.5635 9.57885 9.7666 8.37931 8.67578 8C9.7666 7.62069 10.5635 6.42115 10.5635 5C10.7706 5 10.9385 4.83211 10.9385 4.625V4.375C10.9385 4.16789 10.7706 4 10.5635 4H5.31348ZM7.93848 8.75C8.5763 8.75 9.12406 9.26869 9.39062 10H6.48633C6.75287 9.2688 7.3006 8.75 7.93848 8.75ZM9.56348 5C9.56348 5.35633 9.50113 5.69667 9.39062 6H6.48633C6.37556 5.69608 6.31348 5.35541 6.31348 5H9.56348Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitHourglassCircle);
export default __webpack_public_path__ + "static/media/aitHourglassCircle.1065829505ec323e35ab1d54e128bfdd.svg";
export { ForwardRef as ReactComponent };